<template>
  <div class="">
    <vs-button
      v-if="params.data.meta && params.data.meta.prescription_id" 
      size="small" @click="goToP()" >
      Ver
    </vs-button>
    <p v-else style="font-size: 10px;" class="text-center">
      Sin Receta
    </p>
  </div>
</template>

<script>
export default {
  name: 'CellRendererLink',
  methods: {
    goToP(){
      window.open('/recipes/recipe/view/'+this.params.data.meta.prescription_id, '_blank');
    },
  },
  computed: {
    url () {
      return '/apps/user/user-view/268'

      // Below line will be for actual product
      // Currently it's commented due to demo purpose - Above url is for demo purpose
      // return "/apps/user/user-view/" + this.params.data.id
    }
  }
}
</script>
